/**
 * The words behind the register's shared cells (SA-464 e, the `queueText.ts`
 * beside `queueBits.tsx` precedent): pure functions and a table, kept out
 * of `registerCells.tsx` so that file exports components only
 * (`react-refresh/only-export-components`).
 */
import type { Order, RecordStatus } from '@/types/commerce'

export const STATUS_SOURCE_TITLE: Record<RecordStatus['source'], string> = {
  step: 'From the current step',
  outcome: 'From the outcome',
  condition: 'From the quote',
  override: 'Set by hand',
}

export function words(token: string): string {
  const spaced = token.replace(/_/g, ' ')
  return spaced.charAt(0).toUpperCase() + spaced.slice(1)
}

/** The line under the chip: where the status comes from (the wireframe's
 *  `.stcell .dv`). Step-derived names the step number the row is at. */
export function statusDerivation(status: RecordStatus, order: Order): string {
  switch (status.source) {
    case 'step': {
      const n = order.process?.currentStep?.number
      return n ? `derived from step ${n}` : 'derived from the step'
    }
    case 'outcome': return 'derived from the outcome'
    case 'condition': return 'derived from the quote'
    case 'override': return 'set by hand'
  }
}
